import { Box, Typography } from "@material-ui/core";
import React from "react";

import { InvestmentStyleDiagnosisRequestAvoidSalesStylesEnum as AvoidEnum } from "@/api/generated";
import { AVOID_OPTIONS, DIAGNOSIS_QUESTION_TEXT } from "@/constants/investmentStyleDiagnosisQuestions";

import { DiagnosisInvestmentStyleCheckboxList } from "../DiagnosisInvestmentStyleCheckboxList";

import { useStepStyles } from "./stepStyles";

type AvoidStepProps = {
  avoidSalesStyles: AvoidEnum[];
  onAvoidSalesStylesChange: (next: AvoidEnum[]) => void;
};

const AvoidStep: React.FC<AvoidStepProps> = ({ avoidSalesStyles, onAvoidSalesStylesChange }) => {
  const classes = useStepStyles();
  return (
    <>
      <Typography className={classes.title}>避けたいこと</Typography>
      <Typography className={classes.description}>{DIAGNOSIS_QUESTION_TEXT[19]}</Typography>
      <Box className={classes.inputArea}>
        <DiagnosisInvestmentStyleCheckboxList
          options={AVOID_OPTIONS}
          selected={avoidSalesStyles}
          onChange={onAvoidSalesStylesChange}
        />
      </Box>
    </>
  );
};

export default AvoidStep;
